import { useState, useEffect } from 'react';
import Util from "../../Service/util";
import Service from "../../Service/http";
import { FadeLoader } from "react-spinners";
import { useNavigate } from 'react-router-dom'
import ReactTable from 'react-table-6';
import "react-table-6/react-table.css";
import withFixedColumns from 'react-table-hoc-fixed-columns';
import 'react-table-hoc-fixed-columns/lib/styles.css'
import { Autocomplete, TextField, Checkbox, Button } from '@mui/material';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
const ReactTableFixedColumns = withFixedColumns(ReactTable);
function MentorsList() {
    let [loading, setLoading] = useState(false);
    let [mentors , setMentors] = useState([]);
    let [filteredMentors, setfilteredMentors] = useState([]);
    let [filteredBatches, setfilteredBatches] = useState([]);
    let [batches , setBatches] = useState([]);
    let [mentorIds, setMentorIds ] = useState({});
    let [data, SetData] = useState([]);
    let [Page, SetPage] = useState(1)
    let [FinalPage, SetFinalPage] = useState(-1);
    let [PageSize, SetPageSize] = useState(50)
    let [PageSizeOption, SetPageSizeOption] = useState([5,10,20,25,50,100])
    let [background, SetBackground] = useState("#81C784");
    const service = new Service();
    const util = new Util();
    const navigate = useNavigate()
    useEffect(() => {
        let isLogin = util.loggedIn();
        let admin = util.isAdmin();
        if (!isLogin && window.location.pathname !== "/login" || !admin) {
            window.location.replace("/login");
        }
       
        if(isLogin && admin){
            setLoading(true);
            service.get("api/admin/mentors")
            .then((res) => {
                let mentors = [  "All Mentors" ]
                let obj = {};
                res.data.forEach( ( mentor) => {
                    mentors.push(mentor.name);
                    obj[mentor.name] = mentor._id;
                })
                setMentors(mentors);
                setMentorIds(obj);
            }).catch((err) => {
                console.log(err);
            })

            service.get("api/batches")
            .then((res) => {
                let batches = [  "All Batches" ]
                res.batches.forEach( ( batch) => {
                    batches.push(batch);
                })
                setBatches(batches);
            })
            .catch((err) => {
                console.log(err);
            })
            setLoading(false);
        }

    }, []);

    const handleClick = () => {
        if(filteredMentors.length > 0 && filteredBatches.length > 0){
            setLoading(true);

            let data = {
                mentors : filteredMentors,
                batches : filteredBatches,
                mentorIds : mentorIds
            }
            service.post("api/admin/mentees/list", data)
            .then((res) =>{
                SetData(res.data);
                
            })
            .catch((err)=>{
                console.log(err);
            })
            setLoading(false);


        }
    }

    function PaginationUpdate(){
        let Datalength = data.length;
        if(Datalength === 0 || Datalength === null){
          SetPageSizeOption([5, 10, 15, 25, 50])
        }
        else{
        let pageOptions = []
        let defaultOptions = [5,10,20,25,50,100];
        defaultOptions.forEach(item => {
          const cur = Number(item);
          if(cur <= Datalength){
              pageOptions.push(cur)
          }
        })
        let num = 200;
        while(Number(num) <= Datalength){
          pageOptions.push(Number(num));
          num += 100;
        }
        if(pageOptions[pageOptions.length - 1] != Datalength){
          pageOptions.push(Number(Datalength));
        }
        SetPageSizeOption(pageOptions);
      }
      }
    
      function PopulatedFill(){
        let Datalength = data.length;
        if(Page === FinalPage){
          let cur_size = PageSize;
          if(cur_size === 0){
            cur_size = 10;
          }
          const res = Datalength % cur_size;
          if(!isNaN(res) && res !== 0){
            SetPageSize(res);
          }
        }
      }

      useEffect(() => {
        PaginationUpdate();
      }, [data])
    
      useEffect(() => {
        PopulatedFill();
      }, [Page, FinalPage])
    
    

    return (
        <>
            {
                loading
                    ? <div style={{ marginTop: "10vh", marginRight:"10vh",textAlign:"center"}}><FadeLoader  margin={5} color="green" /></div>
                    :
                    <div className='card' style={{ "marginTop": "5%", marginLeft: "2%", marginRight: "2%" }}>
                        <h1 className='text-center card-title text-primary' style={{ "margin": "2%" }}>Mentee - Mentors</h1>
                        <div>
                            <div className=" text-center card-body m-2">
                            <div className='d-flex justify-content-center  m-2'>
                                <div style={{verticalAlign : "middle", display : "flex", flexDirection : "row"}}>
                                <Autocomplete
                                    multiple
                                    disablePortal
                                    disableCloseOnSelect
                                    id="checkboxes-tags-demo"
                                    style={{ float: 'right' }}
                                    getOptionLabel={(option) => option}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8  }}
                                            checked={selected}
                                        />
                                        {option}
                                        </li>
                                    )}
                                    isOptionEqualToValue = {(option, value) => {
                                        if(option) return filteredBatches.includes(option);
                                        else return false;
                                      }}
                                    options={(filteredBatches.includes('All Batches'))? ['All Batches'] : batches}
                                    sx={{ width: 300 , display: 'inline-block', marginRight: 6, verticalAlign : "middle"}}
                                    onChange={(event, newValue) => {setfilteredBatches(newValue);  }}
                                    renderInput={(params) => <TextField {...params} label="Select Batches" />}
                                    />
                                <Autocomplete
                                    multiple
                                    disablePortal
                                    disableCloseOnSelect
                                    id="checkboxes-tags-demo"
                                    getOptionLabel={(option) => option}
                                    style={{ float: 'left' }}
                                    renderOption={(props, option, { selected }) => (
                                        <li {...props}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8  }}
                                            checked={selected}
                                        />
                                        {option}
                                        </li>
                                    )}
                                    isOptionEqualToValue = {(option, value) => {
                                        if(option) return filteredMentors.includes(option);
                                        else return false;
                                      }}
                                    options={(filteredMentors.includes('All Mentors'))? ['All Mentors'] : mentors}
                                    sx={{ width: 400 , display: 'inline-block', marginRight: 6, verticalAlign : "middle"}}
                                    onChange={(event, newValue) => {setfilteredMentors(newValue);}}
                                    renderInput={(params) => <TextField {...params} label="Select Mentors" />}
                                    />
                                    <Button onClick={handleClick} 
                                    disabled = {loading}
                                    variant="contained" color="primary" style={{
                                    float : "right", width : "20%", height : "50px", verticalAlign : "middle"
                                    }}>
                                    Search</Button>
                                </div>
                            </div>
                            {data.length > 0 ? 
                                <ReactTableFixedColumns
                                    style={{ marginTop: "2%" }}
                                    data={data}
                                    pageSize = {PageSize}
                                    pageSizeOptions = {PageSizeOption}
                                    minRows = {5}
                                    loading = {loading}
                                    loadingText = {'Loading Handles...'}
                                    onPageSizeChange = {(pageSize, pageIndex) =>{
                                    SetPage(pageIndex)
                                    SetPageSize(pageSize)
                                    }}
                                    onPageChange = {(num) => {
                                    SetPage(num);
                                    }}
                                    renderTotalPagesCount = {(num) => {
                                    if(!isFinite(num) || isNaN(num)){
                                        num = 1;
                                    }
                                    SetFinalPage(num);
                                    if(num === 0){
                                        return 1;
                                    }
                                    return num;
                                    }}
                                    columns={
                                        [
                                            {
                                                Header: "MENTOR DETAILS",
                                                fixed : "left",
                                                columns: [
                                                    {
                                                        Header: "NO",
                                                        accessor: "no",
                                                        width : 50,
                                                        getProps: (state, rowInfo, column) => {
                                                            return {
                                                              style: {
                                                                color: (rowInfo) ? 'white' : 'white',
                                                                background: rowInfo ? background : "#0F9ADC",
                                                              },
                                                            };
                                                          },
                                                    },
                                                    {
                                                        Header: "Mentor Name",
                                                        accessor: "mentorName",
                                                        getProps: (state, rowInfo, column) => {
                                                            return {
                                                              style: {
                                                                color: (rowInfo) ? 'white' : 'white',
                                                                background: rowInfo ? background : "#0F9ADC",
                                                              },
                                                            };
                                                          },
                                                    },
                                                    {
                                                        Header: "Mentor Email",
                                                        accessor: "mentorEmail",
                                                        getProps: (state, rowInfo, column) => {
                                                            return {
                                                              style: {
                                                                color: (rowInfo) ? 'white' : 'white',
                                                                background: rowInfo ? background : "#0F9ADC",
                                                              },
                                                            };
                                                          },
                                                    },
                                                ]
                                            },
                                            {
                                                Header: "MENTEE DETAILS",
                                                columns: [
                                                    {
                                                        Header: "Mentee Name",
                                                        accessor: "menteeName",
                                                        getProps: (state, rowInfo, column) => {
                                                            return {
                                                              style: {
                                                                color: (rowInfo) ? "white" : 'black',
                                                                background: rowInfo ?"#66cc66" :"#B2EBF2",
                                                              },
                                                            };
                                                          },
                                                    },
                                                    {
                                                        Header: "Mentee Email",
                                                        accessor: "menteeEmail",
                                                        getProps: (state, rowInfo, column) => {
                                                            return {
                                                              style: {
                                                                color: (rowInfo) ? "white" : 'black',
                                                                background: rowInfo ?"#66cc66" :"#B2EBF2",
                                                              },
                                                            };
                                                          },
                                                    },
                                                ]
                                            }
                                        ]
                                    }
                                    className="-highlight text-dark h5"
                                />
                            
                            : null}

                            </div>
                        </div>
                    </div>
            }
        </>
    )
}

export default MentorsList;
